import { Dispatch, SetStateAction } from 'react';
import { Recipe } from '../../../../services/recipe/recipe.types';

export enum DescriptionUpdateRule {
  NO_ACTION = 0,
  REPLACE_DESCRIPTION = 1,
  APPEND_LONG_DESCRIPTION = 2,
}

export enum FprodUpdateRule {
  NO_ACTION = 0,
  APPLY_NEW = 1,
  COPY_EXISTING = 2,
}

export interface CopyRecipeFormValues {
  description: string;
  longDescription: string;
  fmsProdNo: string;
  fprodUpdateRule: FprodUpdateRule;
  descriptionUpdateRule: DescriptionUpdateRule;
}

export interface UpdateRecipeDetailsProps {
  selectedRecipes: Recipe[];
  setStep: Dispatch<SetStateAction<number>>;
  formValues: CopyRecipeFormValues;
  setFormValues: Dispatch<SetStateAction<CopyRecipeFormValues>>;
  formErrors: Omit<CopyRecipeFormValues, 'fprodUpdateRule' | 'descriptionUpdateRule'>;
  setFormErrors: Dispatch<SetStateAction<Omit<CopyRecipeFormValues, 'fprodUpdateRule' | 'descriptionUpdateRule'>>>;
}
